import React from 'react';
import { FlexDiv, Image } from './design-system/containers';
import { palette } from './design-system/colors';
import { Heading3 } from './design-system/headings';
import { TextDefault } from './design-system/texts';

export function FocusArea({ iconSrc, iconAltText, headingText, text }) {
    return (
        <FlexDiv
            backgroundColor={palette.graphite.cloud}
            borderRadius={16}
            column
            padding={32}
            dropShadowBelow
            borderWidth={1}
            borderColor={palette.graphite.gray}
            borderStyle="solid"
        >
            <FlexDiv gap={8}>
                {iconSrc ? <Image src={iconSrc} alt={iconAltText} /> : null}
                <Heading3>{headingText}</Heading3>
            </FlexDiv>
            <TextDefault>{text}</TextDefault>
        </FlexDiv>
    );
}
